var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("reports-title", { attrs: { title: _vm.pageTitle } }),
      _vm._v(" "),
      _c("reports-toolbar", {
        attrs: {
          "drop-menu": _vm.menu,
          "range-value": _vm.toolbarRange,
          "report-title": _vm.pageTitle,
          "toolbar-disabled": _vm.isStatic,
        },
        on: { onSelectDropdown: _vm.onChangeCalculationMode },
      }),
      _vm._v(" "),
      _vm.isShowSkeleton
        ? _c("skeleton-wrapper", {
            attrs: { id: "skeletonWrapper" },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("line-chart", {
                        attrs: {
                          id: "report_export_id",
                          config: _vm.stubConfig,
                          "is-static": true,
                          "show-stub-message": false,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3437902539
            ),
          })
        : _c("line-chart", {
            attrs: {
              id: "report_export_id",
              config: _vm.chartConfig,
              "is-static": _vm.isStatic,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }